import { Button, ButtonGroup, Modal } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISimpleMessageDto } from "../../models/dto/application/ISimpleMessageDto";

export default function SimpleMessageModal(props: any) {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [title, setTitle] = useState('');
    const [t] = useTranslation("global");
    const simpleMessage: ISimpleMessageDto = props.simpleMessage;

    useEffect(() => {
        setOpen(simpleMessage.showModal);
        setMessage(simpleMessage.modalMessage);
        setTitle(simpleMessage.modalTitle);
    }, [props.simpleMessage])
    return (
        <div style={{ position: 'relative' }}>
            <Modal
                align="start"
                id="modal-id"
                closeButton
                show={open}
                onClose={() => setOpen(false)}
                footer={(
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={() => setOpen(false)}>{t("header.accept")}</Button>
                    </div>
                )}
                title={title}>
                <p>
                    {message}
                </p>
            </Modal>
        </div>
    );
}